import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import EstateVisualItem from "@/components/estates/visual/estateVisualItem"
import FsLightbox from "fslightbox-react"
import { VisualContainer } from "@/components/estates/estatesStyle"

const EstateVisualContainer = ({ sections }) => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  })

  const urls = []
  sections.forEach(section => {
    section.items.forEach(item => {
      urls.push(item.imgLarge || item.img)
    })
  })

  function openLightboxOnSlide(slide) {
    const index = urls.findIndex(url => url === slide)

    setLightboxController({
      slide: index + 1,
      toggler: !lightboxController.toggler,
    })
  }
  return (
    <VisualContainer className="visual">
      <Container className="no-padding">
        {sections.map(section => (
          <Row>
            <Col className="no-padding wiz-title" xs="12">
              <h2> {section.title}</h2>
            </Col>
            {section.items.map(item => (
              <EstateVisualItem item={item} onClick={openLightboxOnSlide} />
            ))}
          </Row>
        ))}
        <FsLightbox
          toggler={lightboxController.toggler}
          sources={urls}
          slide={lightboxController.slide}
        />
      </Container>
      <div className="flats"></div>
    </VisualContainer>
  )
}

export default EstateVisualContainer
